module.exports = __webpack_public_path__ + "img/8.68d17120.jpg";